/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Onboarding_Complete_Resume_UploadedInputs */

const en_onboarding_complete_resume_uploaded = /** @type {(inputs: Onboarding_Complete_Resume_UploadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploaded: ${i?.name}`)
};

const de_onboarding_complete_resume_uploaded = /** @type {(inputs: Onboarding_Complete_Resume_UploadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hochgeladen: ${i?.name}`)
};

const fr_onboarding_complete_resume_uploaded = /** @type {(inputs: Onboarding_Complete_Resume_UploadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Téléchargé : ${i?.name}`)
};

const es_onboarding_complete_resume_uploaded = /** @type {(inputs: Onboarding_Complete_Resume_UploadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subido: ${i?.name}`)
};

const it_onboarding_complete_resume_uploaded = /** @type {(inputs: Onboarding_Complete_Resume_UploadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caricato: ${i?.name}`)
};

const nl_onboarding_complete_resume_uploaded = /** @type {(inputs: Onboarding_Complete_Resume_UploadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geüpload: ${i?.name}`)
};

const pl_onboarding_complete_resume_uploaded = /** @type {(inputs: Onboarding_Complete_Resume_UploadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wgrane: ${i?.name}`)
};

const fi_onboarding_complete_resume_uploaded = /** @type {(inputs: Onboarding_Complete_Resume_UploadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ladattu: ${i?.name}`)
};

const da_onboarding_complete_resume_uploaded = /** @type {(inputs: Onboarding_Complete_Resume_UploadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploadet: ${i?.name}`)
};

const sv_onboarding_complete_resume_uploaded = /** @type {(inputs: Onboarding_Complete_Resume_UploadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uppladdat: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Uploaded: {name}" |
*
* @param {Onboarding_Complete_Resume_UploadedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_complete_resume_uploaded = /** @type {((inputs: Onboarding_Complete_Resume_UploadedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Complete_Resume_UploadedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_complete_resume_uploaded(inputs)
	if (locale === "fr") return fr_onboarding_complete_resume_uploaded(inputs)
	if (locale === "es") return es_onboarding_complete_resume_uploaded(inputs)
	if (locale === "it") return it_onboarding_complete_resume_uploaded(inputs)
	if (locale === "nl") return nl_onboarding_complete_resume_uploaded(inputs)
	if (locale === "pl") return pl_onboarding_complete_resume_uploaded(inputs)
	if (locale === "fi") return fi_onboarding_complete_resume_uploaded(inputs)
	if (locale === "da") return da_onboarding_complete_resume_uploaded(inputs)
	if (locale === "sv") return sv_onboarding_complete_resume_uploaded(inputs)
	return en_onboarding_complete_resume_uploaded(inputs)
});